<template>
    <div>
        <h3 class="title is-3 has-text-centered">{{ $filters.ucfirst(heading) }}</h3>

        <div class="columns is-multiline">
            <div class="column">
                <o-table class="is-responsive is-responsive-xs-desktop"
                         v-if="isTableVisible"
                         :data="processedData"
                         :bordered="table.bordered"
                         :striped="table.striped"
                         :narrowed="table.narrowed"
                         :checkable="false"
                         :mobile-cards="table.mobileCards"
                         :paginated="table.paginated"
                         :pagination-simple="table.paginationSimple"
                         :per-page="table.perPage"
                         default-sort-direction="asc"
                         default-sort="name"
                >
                    <template>
                        <o-table-column #default="{ row }" field="name" label="Name" sortable>
                            {{ row.name }}
                        </o-table-column>
                        <o-table-column #default="{ row }" field="reimbursable" label="Reimbursable" sortable>
                            {{ $filters.yesNo(row.reimbursable) }}
                        </o-table-column>
                        <o-table-column #default="{ row }" field="qty" label="QTY" sortable>
                            <div @click="showWeeklyUserBilling(row.userId, row.reimbursable)">
                                <a @click.prevent>{{ row.qty }}</a>
                            </div>
                        </o-table-column>
                        <o-table-column #default="{ row }" field="price" label="Amount" sortable>
                            {{ $filters.valueOrDefault($filters.currency(row.price), '–') }}
                        </o-table-column>
                        <o-table-column #default="{ row }" field="avg" label="Average" sortable>
                            {{ $filters.valueOrDefault($filters.currency(row.avg), '–') }}
                        </o-table-column>
                    </template>
                    <template #footer v-if="processedData.length > 0">
                      <th colspan="2">Total</th>
                      <th class="value">{{ summary.qty }}</th>
                      <th class="value">{{ $filters.valueOrDefault($filters.currency(summary.total), "-") }}</th>
                      <th></th>
                    </template>
                  <template #empty>
                    <div class="has-text-centered">
                      This table is empty!
                    </div>
                  </template>
                </o-table>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
import Table from './../../../../mixins/Table'

    export default {
        mixins: [Table],

        props: ['heading', 'data', 'week'],

        computed: {
            ...mapGetters(['userNameById', 'isBillingReimbVisible']),

            processedData() {
                if (!_.isArray(this.data)) {
                    return []
                }

                return _.reduce(this.data, (res, row) => {
                    let qty_billed = parseInt(row.qty_billed),
                        price_billed = parseInt(row.price_billed),
                        qty_reimb = parseInt(row.qty_reimb),
                        price_reimb = parseInt(row.price_reimb),
                        name = this.userNameById(row.user_id),
                        userId = row.user_id

                    res.push({name, qty: qty_billed, price: price_billed, userId, avg: qty_billed > 0 ? (price_billed / qty_billed) : 0, reimbursable: false})

                    if (this.isBillingReimbVisible) {
                        res.push({name, qty: qty_reimb, price: price_reimb, userId, avg: qty_reimb > 0 ? (price_reimb / qty_reimb) : 0, reimbursable: true})
                    }

                    return res
                }, [])
            },
        summary() {
            const data = this.processedData || [];
            return data.reduce(
                (res, item) => {
                    res.total += item.price;
                    res.qty += item.qty;
                    return res;
                },
                { qty: 0, total: 0 }
            );
        },
    },

        methods: {
            showWeeklyUserBilling(userId, reimb) {
                this.$emit('row-clicked', this.week, userId, reimb)
            }
        }
    }
</script>
